import { ChangeDetectorRef, Component, forwardRef, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


const TOGGLE_VALUE_ACCESSOR_PROVIDER = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ToggleComponent),
    multi: true,
};

@Component({
    selector: 'ui-toggle',
    providers: [TOGGLE_VALUE_ACCESSOR_PROVIDER],
    styles: [
        `
            :host {
                line-height: 1em;
            }
            .host {
                position: relative;
                display: inline-block;
                width: calc(2em + 8px);
                height: calc(1em + 4px);
                vertical-align: middle;
            }

            .host.active .slider:before {
                transform: translateX(calc(1em + 4px));
            }

            .slider {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                transition: .2s;
                border-radius: calc(1em + 2px);
            }

            .slider:before {
                position: absolute;
                content: "";
                text-align: center;
                line-height: 1em;
                height: 1em;
                width: 1em;
                border-radius: 50%;
                left: 2px;
                bottom: 2px;
                background: white;
                box-shadow: 0 0.15em 0.2em 0 rgba(0, 0, 0, 0.3);
                transition: .2s;
            }
            .slider.disabled {
                background-color: #859099;
            }
        `,
    ],
    template: `
        <div
            role="checkbox"
            class="host"
            [class.active]="checked"
            [attr.tabindex]="disabled ? null : '0'"
            [attr.aria-checked]="checked ? 'true' : 'false'"
            (click)="onClick($event)">
            <div
                class="slider"
                [class.bg-dark]="!checked && !disabled"
                [class.bg-success]="checked && !disabled"
                [class.disabled]="disabled"
                [class.cursor-pointer]="!disabled">
            </div>
        </div>
    `,
})
export class ToggleComponent implements ControlValueAccessor {

    checked = false;

    @Input() preventDefault = false;

    @Input() disabled = false;

    private onChange = (_: boolean) => {};

    private onTouched = () => {};

    constructor(private cdr: ChangeDetectorRef) {}

    /**
     * handler for [for] directive
     */
    @HostListener('click', ['$event'])
    onHostClick(event: Event) {
        this.onClick(event);
    }

    onClick(event: Event) {
        event.stopImmediatePropagation();
        if (this.disabled) {
            return;
        }
        if (!this.preventDefault) {
            this.checked = !this.checked;
            this.cdr.detectChanges();
        }
        this.onChange(this.checked);
        this.onTouched();
    }

    writeValue(obj: any): void {
        this.checked = !!obj;
        // propagate changes to template
        // can't use HostBindings because it uses host's ChangeDetectorRef
        // see: https://github.com/angular/angular/issues/22560
        this.cdr.detectChanges();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }
}
